import type { Nullable } from '../../types/common'
// import { checkMobileVersion } from '../../utils/check-media'
// import { debounce } from '../../utils/debounce'
import BaseComponent from '../base-component/base-component'
import type CartDrawer from './cart-drawer'

class CartDrawerFooter extends BaseComponent {
  // swipeAreaSelector: string
  // swipeBarSelector: string
  // swipeArea: Nullable<HTMLElement>
  // swipeAreaBar: Nullable<HTMLElement>
  // expandableElementSelector: string
  // expandableElements: HTMLElement[]
  // touchStart: number
  // isExpanded: boolean
  // resizeObserver: ResizeObserver
  // isMobile: boolean

  cartDrawer: Nullable<CartDrawer>

  constructor() {
    super()

    // this.swipeAreaSelector = 'data-swipe-area'
    // this.swipeBarSelector = 'data-swipe-area-bar'
    // this.expandableElementSelector = 'data-cart-drawer-expandable-element'
    this.cartDrawer = this.closest('cart-drawer')
    // this.swipeArea = this.querySelector(`[${this.swipeAreaSelector}]`)
    // this.swipeAreaBar = this.querySelector(`[${this.swipeBarSelector}]`)
    // this.isExpanded = true
    // this.expandableElements = [
    //   ...this.querySelectorAll(`[${this.expandableElementSelector}]`),
    // ] as HTMLElement[]

    // this.isMobile = checkMobileVersion()
    // this.resizeObserver = new ResizeObserver(this.handleResize)
  }

  connectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.subscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }

    // this.init()

    // this.swipeArea.addEventListener('touchstart', this.handleTouchStart)
    // this.swipeArea.addEventListener('touchend', this.handleTouchEnd)
    // this.swipeAreaBar.addEventListener('click', this.handleBarClick)

    // this.resizeObserver.observe(this.cartDrawer)
  }

  disconnectedCallback(): void {
    if (this.cartDrawer) {
      this.cartDrawer.unsubscribe(
        'update-nodes',
        this.handleCartDrawerFinishUpdate,
      )
    }

    // this.swipeArea.removeEventListener('touchstart', this.handleTouchStart)
    // this.swipeArea.removeEventListener('touchend', this.handleTouchEnd)
    // this.swipeAreaBar.removeEventListener('click', this.handleBarClick)
  }

  handleCartDrawerFinishUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const newItems = node.querySelector('cart-drawer-footer')

    if (!newItems) {
      return
    }

    const clonedNewItems = newItems.cloneNode(true)

    this.replaceChildren(...clonedNewItems.childNodes)
  }

  // handleTouchStart = (event: TouchEvent): void => {
  //   this.touchStart = event.touches[0].clientY
  // }

  // handleTouchEnd = (event: TouchEvent): void => {
  //   const touchEnd = event.changedTouches[0].clientY

  //   if (touchEnd === this.touchStart) {
  //     return
  //   }

  //   const isExpand = touchEnd < this.touchStart

  //   this.setExpandState(isExpand)
  // }

  // handleBarClick = (): void => {
  //   this.setExpandState(!this.isExpanded)
  // }

  // handleResize = debounce((): void => {
  //   this.init()
  // }, 100)

  // init() {
  //   this.isMobile = checkMobileVersion()

  //   this.setExpandState(!this.isMobile)
  // }

  // setExpandState(isExpand: boolean): void {
  //   this.isExpanded = isExpand

  //   this.expandableElements.forEach(element => {
  //     const maxHeight = isExpand ? element.scrollHeight : 0

  //     element.style.maxHeight = `${maxHeight}px`
  //   })
  // }
}

export default CartDrawerFooter
